var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-col',{attrs:{"xs":24,"sm":24,"md":_vm.md,"lg":_vm.lg,"xl":_vm.xl}},[_c('div',{staticClass:"s-view-item"},[_c('div',{staticClass:"f-base"},[_vm._v(_vm._s(_vm.realLabel))]),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }